<template>
  <Card :btnMsg="$t('channelSelect.btn_text')" @changeStep="changeStep">
    <div class="card-channelSelect">
      <div class="card-content">
        <p class="card-title" v-html="$t('channelSelect.title')"></p>
        <p class="card-text" v-html="$t('channelSelect.text')"></p>

        <div class="card-swipe">
          <!-- 轮播图部分 -->
          <van-swipe ref="mySwipe" @change="changeSwipeIdx" indicator-color="#f4a300">
            <van-swipe-item v-for="item in form.good_review_channels" :key="item.id">
              <img :src="item.channel_pic" alt="Gift" class="card-image" />
            </van-swipe-item>
          </van-swipe>
          <!-- 左右箭头 -->
          <van-button class="swipe-arrow prev-arrow" @click="prev">
            <van-icon class="arrow" name="arrow-left" />
          </van-button>
          <van-button class="swipe-arrow next-arrow" @click="next">
            <van-icon class="arrow" name="arrow" />
          </van-button>
        </div>
      </div>

      <div class="card-footer">
        <p class="footer-note" v-html="$t('channelSelect.footer')"></p>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from '@/components/card.vue';

export default {
  components: {
    Card,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
      currentIndex: 0,
    };
  },
  mounted() {
    this.form = this.value;
  },
  methods: {
    prev() {
      this.$refs.mySwipe.prev();
    },
    next() {
      this.$refs.mySwipe.next();
    },
    changeSwipeIdx(v) {
      this.currentIndex = v;
    },
    changeStep() {
      let item = this.form.good_review_channels[this.currentIndex];
      this.form.good_review_channel_id = item.id;
      this.form.channel_type = item.channel_type;
      this.form.channel_pic = item.channel_pic;
      // channel_type 0 礼品卡
      // channel_type 1 实体礼物
      // channel_type 2 paypal
      this.$emit('input', this.form);
      this.$parent.changeStep('uploadPic',this.form);
    },
  },
};
</script>

<style lang="scss">
.card-channelSelect {
  position: relative;
  width: 100%;
  .card-title {
    font-size: 24px;
    font-weight: 500;
    color: #1a1a1a;
    margin-bottom: 20px;
  }
  .card-text {
    font-size: 17px;
    font-weight: 400;
    color: #1a1a1a;
    margin-bottom: 20px;
  }
  .card-swipe {
    position: relative;
    margin-bottom: 10px;
    border-radius: 8px;
    .van-swipe {
      border-radius: 8px;
    }
  }
  .card-swipe .van-swipe-item {
    width: 100%;
    border-radius: 8px;
  }

  .card-image {
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }

  .card-footer {
    padding: 10px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .footer-note {
    font-size: 16px;
    color: #777;
    margin-bottom: 10px;
  }

  .swipe-arrow {
    width: 28px;
    border: none;
    height: 28px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    color: #000;
    font-size: 24px;
    background-color: #ffd814;
    padding: 0;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    border-radius: 2px;
  }

  .prev-arrow {
    left: 6px;
  }

  .next-arrow {
    right: 6px;
  }

  .van-swipe__indicator .van-swipe__indicator-item {
    background-color: #fff;
  }

  .van-swipe__indicator .van-swipe__indicator-item--active {
    background-color: #f4a300; /* 高亮颜色 */
  }
  .van-swipe__track {
    display: flex;
    align-items: center;
  }
  .van-swipe {
    border: 1px solid #f4a300;
    // background: linear-gradient(180deg, rgba(245, 200, 0, 0.6666666667), #ffa031);
    background: #fff;
  }
}
</style>
